import { render, staticRenderFns } from "./paginationLayout.vue?vue&type=template&id=2cf18e86&scoped=true&"
import script from "./paginationLayout.vue?vue&type=script&lang=js&"
export * from "./paginationLayout.vue?vue&type=script&lang=js&"
import style0 from "./paginationLayout.vue?vue&type=style&index=0&id=2cf18e86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf18e86",
  null
  
)

export default component.exports